/* eslint-disable @typescript-eslint/no-explicit-any */

declare global {
  interface Window {
    __GP_EVENTS__: {};
    _pageFonts: [];
    _themeFonts: [];
    _pageLibs: [];
    _pageLibsBlocked: [];
    _mailchimpData: [];
    $gfPlaceHolders: JQuery;
    $gfVSPlaceHolders: JQuery;
    _placeHolders: [
      | {
          id: number;
          top: number;
          left: number;
          width: number;
        }
      | undefined,
    ];

    _iframeWindow: any;

    _isDetached: false | true;
    _isScrolling: false;
    _isHistoryEditing: false;
    _isContextOpenned: false;

    _showToolList: [];
    _hideToolList: [];

    _zoomOut: 1;

    _gTimeOut: any;
    _contentChangeTimeout: any;
    _detechContentChangeTimeout: any;

    _toolTimeout: any; // cho phần hover tool

    _addContentBtn: '<span class="gf_add-content"><span class="gf_add-content-span"></span></span>';

    _productDynamic: any;
    _webSocket: any;
    _isCSSOverWrite: [];
    _isFirstLoad: true;
    _isFirstLoadList: true;
    _isFirstLoadRelated: true;
    _isFirstLoadCollection: boolean;
    _collectionJsonData: any;
    _collectionStackElement: [];

    _productArray: []; // list of preloaded products
    _productLatest: any;
    _productListArray: [];
    _blogsJsonData: {};

    // New variable

    // gfDraggable.ts
    _counter: 0;

    // Tracking
    intercomSettings: {
      app_id: string;
      name: string | undefined;
      email: string | undefined;
      created_at: number | undefined;
      Shopify: string | undefined;
      Plan: string | undefined;
      utm_term: string | undefined;
    };
    _fs_debug: boolean;
    _fs_host: string;
    _fs_script: string;
    _fs_org: string;
    _fs_namespace: string;
    $crisp: any[];
    ___gemShopInfo: TypeShop;
    uuid: string;
    __initRunning: boolean;
  }
}

window._pageFonts = [];
window._themeFonts = [];
window._pageLibs = [];
window._pageLibsBlocked = []; //danh sách các libs bị blocked bởi CookieYes
window._mailchimpData = [];

// Fix typescript version tạm thời để code khởi tạo trong file: gryffEditor.js
// window.$gfPlaceHolders = [];
// window.$gfVSPlaceHolders = [];
// window._placeHolders = [];

window._isDetached = false;
window._isScrolling = false;
window._isHistoryEditing = false;
window._isContextOpenned = false;

window._showToolList = [];
window._hideToolList = [];

window._zoomOut = 1;

window._gTimeOut = null;
window._contentChangeTimeout = null;
window._detechContentChangeTimeout = null;

window._toolTimeout = null; // cho phần hover tool

window._addContentBtn = '<span class="gf_add-content"><span class="gf_add-content-span"></span></span>';

window._isCSSOverWrite = [];
window._isFirstLoad = true;
window._isFirstLoadList = true;
window._isFirstLoadRelated = true;
window._isFirstLoadCollection = true;
window._collectionJsonData = {};
window._collectionStackElement = [];
window._blogsJsonData = {};

window._productArray = []; // list of preloaded products
window._productLatest = {};
window._productListArray = [];
window._productDynamic = {};
window._webSocket = null;

import '@/app/editor/wapper/tracking.ts';
import '@/app/editor/style.scss';

import type { TypePage } from '@/app/types/editor/page';

import type { TypeShop } from '@/app/types/editor/shop';
import store from '@/app/store/store';
// import config from "@/app/editor/config/index";

import { Wapper } from '@/app/editor/wapper/index';
const wapper = new Wapper();

import { IFrame } from '@/app/editor/iframe/index';
import { Header } from '@/app/editor/header/index';
import { Sidebar } from '@/app/editor/sidebar/index';

const fetched = {
  __shop: false,
  __page: false,
  __snippets: false,
};

/**
 * Initiate editor
 */
const initEditor = () => {
  const shop = store.getValue('__shop') as TypeShop;
  const page = store.getValue('__page') as TypePage;
  const snippets = store.getValue('__snippets') as TypePage;

  if (shop && page) {
    if (page.runningCampaignId && page.runningCampaignId > 0) {
      /**
       * When page is running AB Testing => block calling unneeded api
       * Turn off s
       */
      $('#gfContainer').removeClass('gfContainer-loading');
      const $gfFrameLoader = jQuery('#gfFrameLoader');
      $gfFrameLoader.fadeOut(400, function () {
        $gfFrameLoader.hide();
        $gfFrameLoader.removeClass('show');
      });
      return;
    }
    if (snippets) {
      new IFrame();
      // GRYFF JavaScript
      $(document).ready(function () {
        ($('#gfFrame') as any).gfFrame();
      });
    }
    new Header();
    const sidebar = new Sidebar();
    sidebar.Init();
  }
};

store.onChange('__shop', () => {
  if (fetched['__shop']) {
    return;
  }
  initEditor();
  fetched['__shop'] = true;
  store.unset('__shop');
});

store.onChange('__page', () => {
  if (fetched['__page']) {
    return;
  }
  initEditor();
  fetched['__page'] = true;
  store.unset('__page');
});

store.onChange('__snippets', () => {
  if (fetched['__snippets']) {
    return;
  }
  initEditor();
  fetched['__snippets'] = true;
  store.unset('__snippets');
});

wapper.Init();
